import axios from 'axios';
import { API_CORE_URL } from '../constantes/constantes';

/**
 * Obtiene la información detallada de un partido por su ID.
 *
 * @param {string} matchId - ID del partido a consultar.
 *                          Ej: 'eavt1b8lsd2sqjon7nk03i3o4'
 * @returns {Promise<{ data: any, statusCode: number }>} Objeto con los datos del partido o estado del error.
 */
export async function getPartidoTV(matchId) {
  try {
    if (!matchId) {
      throw new Error('El ID del partido es requerido');
    }

    const url = `${API_CORE_URL}events/match/${matchId}`;

    const { data, status } = await axios.get(url, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    return { statusCode: status, data };
  } catch (error) {
    console.error('Error en la petición getPartidoTV:', error.message || error);

    const status = error.response?.status || 500;
    return { statusCode: status, data: null };
  }
}
